"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableWidgetToolbarType = exports.TableToolbar = void 0;
var react_1 = __importDefault(require("react"));
var react_addons_css_transition_group_1 = __importDefault(require("react-addons-css-transition-group"));
var ContextualTableStyle_1 = __importDefault(require("DreamCoat/Contextual/ContextualTableStyle/ContextualTableStyle"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var Types_1 = require("DataStores/Account/Types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var TableToolbar = (function (_super) {
    __extends(TableToolbar, _super);
    function TableToolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleShowStyle = function (event) {
            event.stopPropagation();
            _this.showContextualStyle = !_this.showContextualStyle;
        };
        _this.showContextualStyle = false;
        return _this;
    }
    TableToolbar.prototype.render = function () {
        var _a = this.props, usingTCDC = _a.usingTCDC, stylePermissionStore = _a.stylePermissionStore, onDelete = _a.onDelete, onMouseEnterDelete = _a.onMouseEnterDelete, onMouseLeaveDelete = _a.onMouseLeaveDelete, blockStore = _a.blockStore, brandStore = _a.brandStore, reselectText = _a.reselectText, toolbarRef = _a.toolbarRef, toolbarType = _a.toolbarType, allowContextualStyling = _a.allowContextualStyling;
        return (react_1.default.createElement(react_addons_css_transition_group_1.default, { transitionName: "fade", transitionEnterTimeout: 150, transitionLeaveTimeout: 150, component: react_1.default.Fragment },
            react_1.default.createElement("div", { className: "editor-toolbar table-widget__toolbar", style: this.toolbarPositioning, ref: toolbarRef },
                toolbarType === TableWidgetToolbarType.WholeTable &&
                    usingTCDC &&
                    stylePermissionStore &&
                    stylePermissionStore.allowStyle(Types_1.StyleAccessType.ToolbarTable) &&
                    allowContextualStyling && (react_1.default.createElement("div", { className: (0, classnames_1.default)([
                        "table-widget__styler",
                        "editor-toolbar__button",
                        {
                            "editor-toolbar__button--active": this.showContextualStyle,
                        },
                    ]), onMouseDown: this.toggleShowStyle },
                    react_1.default.createElement(icons_1.Styles, null))),
                react_1.default.createElement("div", { className: "table-widget__deleter editor-toolbar__button", onMouseDown: onDelete, onMouseEnter: onMouseEnterDelete, onMouseLeave: onMouseLeaveDelete },
                    react_1.default.createElement(icons_1.Delete, null)),
                react_1.default.createElement("div", { className: "contextual-table-style", onMouseDown: function (event) { return event.stopPropagation(); } },
                    react_1.default.createElement(react_addons_css_transition_group_1.default, { transitionName: "fade", transitionEnterTimeout: 150, transitionLeaveTimeout: 150, component: react_1.default.Fragment }, this.showContextualStyle && (react_1.default.createElement(ContextualTableStyle_1.default, { blockStore: blockStore, brandStore: brandStore, reselectText: reselectText })))))));
    };
    Object.defineProperty(TableToolbar.prototype, "toolbarPositioning", {
        get: function () {
            var _a = this.props, leftPosition = _a.leftPosition, toolbarType = _a.toolbarType, topPosition = _a.topPosition;
            var left = toolbarType === TableWidgetToolbarType.WholeTable ? leftPosition : "calc(".concat(leftPosition, " - 22.5px)");
            var position = toolbarType === TableWidgetToolbarType.WholeTable ? "fixed" : "absolute";
            var top = topPosition;
            return {
                left: left,
                top: top,
                position: position,
            };
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], TableToolbar.prototype, "showContextualStyle", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], TableToolbar.prototype, "toolbarPositioning", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TableToolbar.prototype, "toggleShowStyle", void 0);
    TableToolbar = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], TableToolbar);
    return TableToolbar;
}(react_1.default.Component));
exports.TableToolbar = TableToolbar;
var TableWidgetToolbarType;
(function (TableWidgetToolbarType) {
    TableWidgetToolbarType["Row"] = "row";
    TableWidgetToolbarType["Column"] = "column";
    TableWidgetToolbarType["WholeTable"] = "wholetable";
})(TableWidgetToolbarType = exports.TableWidgetToolbarType || (exports.TableWidgetToolbarType = {}));
